import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';

import { useGetDta } from '../../hooks/useGetDta';
import { uploadFile } from '../../api/fetch';
import LoadinSpin from '../ui/LoadinSpin';
import FileUploader from '../FileUploader';
import { useContextInfo } from '../../context/ContextInfo';
const baseUrl = process.env.REACT_APP_API;

const LogoPrint = () => {
    const [img, setImg] = useState('');
    const { setResp } = useContextInfo();

    const { loading, data } = useGetDta('main/general/print');
    useEffect(() => {
        if (data) setImg(data.foto);
    }, [data]);
    const saveFile = async (files) => {
        let bodyContent = new FormData();
        bodyContent.append('archivo', files[0]);

        const res = await uploadFile(bodyContent, `uploads/logo`);
        if (res.ok) setResp(res);
        if (res.modelo) setImg(res.modelo.foto);
    };
    if (loading) return <LoadinSpin />;
    return (
        <>
            <Card>
                <Card.Header> Logo facturas y recibo PNG (Max 20 M)</Card.Header>{' '}
                <Card.Body>
                    <img src={baseUrl + img} alt="" style={{ width: '30%' }} className="text-center" />
                    <FileUploader onFileUpload={saveFile} />
                </Card.Body>
            </Card>
        </>
    );
};

export default LogoPrint;
